"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var CardContent_1 = __importDefault(require("./CardContent"));
var CardHeader_1 = __importDefault(require("./CardHeader"));
var CardFooter_1 = __importDefault(require("./CardFooter"));
var CardDivider_1 = __importDefault(require("./CardDivider"));
var react_2 = require("react");
var constant_1 = require("../../constant");
var context_1 = require("./context");
var style_1 = require("../../style");
var createCardStyle = function (theme, onSelect, selected) { return (__assign(__assign({}, theme.content), { border: selected ? "1px solid " + style_1.DesignSystemThemeColor.Primary.DEFAULT : theme.border, ':hover': {
        boxShadow: onSelect && !selected
            ? '0px 2px 4px -2px rgba(16, 24, 37, 0.08), 0px 4px 8px -2px rgba(16, 24, 37, 0.2)'
            : undefined,
    }, borderRadius: theme.name === constant_1.DESIGN_SYSTEM ? 8 : 2, margin: 10 })); };
var Card = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'lg' : _b, onSelect = _a.onSelect, selected = _a.selected, props = __rest(_a, ["size", "onSelect", "selected"]);
    var theme = react_1.useTheme();
    var cardStyle = react_2.useMemo(function () { return createCardStyle(theme, onSelect, selected); }, [theme, onSelect, selected]);
    var contextValue = react_2.useMemo(function () { return ({
        size: size,
    }); }, [size]);
    return (react_1.jsx(context_1.CardProvider, { value: contextValue },
        react_1.jsx("div", __assign({ css: cardStyle, onClick: onSelect }, props))));
};
exports.default = Object.assign(Card, { Content: CardContent_1.default, Header: CardHeader_1.default, Footer: CardFooter_1.default, Divider: CardDivider_1.default });
